import React from 'react'
import { FilterTabWrapper } from './styles'
import { useFormContext } from 'react-hook-form'
import { SearchButton } from '../Button'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import RegisterMultiSelect from '../RegisterMultiSelect'
import { dropDownContentListApi } from '../../features/dropdown/dropdownAPI'
import { dropdownCategory, getDropDownOptions } from '../../common/const'
import { fieldNames } from './Defines/forkliftDetailTabDefine'

export default function DetailVehicleTab (props) {
  const { onSearchSubmit } = props
  const { register, handleSubmit, formState: { errors }, setError, getValues, setValue, clearErrors, watch } = useFormContext()
  const [errorFields, setErrorFields] = React.useState([])
  const [DropDownList, setDropDownList] = React.useState({})
  const code = watch('code')

  React.useEffect(() => {
    setDropDownList({})
    // Get DropDown data
    const dropdownKey = {
      0: dropdownCategory.dashcamManufacturer_Forklift,
      1: dropdownCategory.horizontalLaserManufacturer,
      2: dropdownCategory.rearLightingManufacturer,
      3: dropdownCategory.sensorsManufacturer
    }
    Object.entries(dropdownKey).map(async (value) => {
      const response = await dropDownContentListApi({ categoryId: value[1] })
      // setDropDownListを更新
      setDropDownList(prevState => ({ ...prevState, [value[1]]: response.data.rows }))
    })
  }, [])

  const onSubmit = data => {
    onSearchSubmit(data)
  }

  const addZeroBeforeDot = (item) => {
    if (getValues(item).length === 1) {
      getValues(item).charAt(0) === '.' && setValue(item, `0${getValues(item)}0`)
    } else {
      getValues(item).charAt(0) === '.' && setValue(item, `0${getValues(item)}`)
    }
  }

  const onNumberBlur = field => () => {
    getValues(`${field}.from`) && addZeroBeforeDot(`${field}.from`)
    getValues(`${field}.to`) && addZeroBeforeDot(`${field}.to`)
    clearErrors([`${field}.from`, `${field}.to`])
    const index = errorFields.indexOf(`${field}.from`)
    if (index > -1) {
      errorFields.splice(index, 1)
    }
    const from = getValues(`${field}.from`)
    const to = getValues(`${field}.to`)
    if (parseFloat(from) > parseFloat(to) && !Number.isNaN(parseFloat(from)) && !Number.isNaN(parseFloat(to))) {
      setError(`${field}.from`, {
        type: 'manual',
        message: i18n.t('VEHICLE_VEHICLE-LIST_POPUP-WARNING2_LABEL')
      })
      setErrorFields(prevState => [...prevState, `${field}.from`])
    }
    if ((from && !/^[0-9.]*$/.test(from)) || (to && !/^[0-9.]*$/.test(to))) {
      setError(`${field}.from`, {
        type: 'manual',
        message: i18n.t('VEHICLE_VEHICLE-LIST_WARNING-NUMERIC_LABEL')
      })
      setErrorFields(prevState => [...prevState, `${field}.from`])
    }
  }

  const onDateBlur = field => () => {
    clearErrors([`${field}.from`, `${field}.to`])
    const from = Date.parse(getValues(`${field}.from`))
    const to = Date.parse(getValues(`${field}.to`))
    if (from > to && !Number.isNaN(from) && !Number.isNaN(to)) {
      setError(`${field}.from`, {
        type: 'manual',
        message: i18n.t('VEHICLE_VEHICLE-LIST_POPUP-WARNING2_LABEL')
      })
      setErrorFields(prevState => [...prevState, `${field}.from`])
    } else {
      const index = errorFields.indexOf(`${field}.from`)
      if (index > -1) {
        errorFields.splice(index, 1)
      }
    }
  }

  const renderErrorText = field => {
    let errorMessage = ''
    if (errors[field]) {
      errorMessage = errors[field].message || errors[field].from.message
    }
    return errorMessage ? <p data-testid={`${field}-error-text`} className="error-text">{`${errorMessage}`}</p> : ''
  }

  const renderInput = options => {
    let component = ''
    // 他のタブで宣言しているためsetValue
    if (options.name === 'code') {
      return (
        <input
          className="input-item"
          type={options.type}
          tabIndex={options.tabIndexes[0]}
          maxLength={options.maxLength}
          data-testid={options.name}
          value={code || ''}
          onChange={(e) => setValue('code', e.target.value)}
        />
      )
    }
    switch (options.type) {
      case 'dropdown':
        component =
            <RegisterMultiSelect
              className="input-item"
              marginLeft={'10px'}
              placeholder={i18n.t('COMMON_COMMON_DROPDOWN-OPTION-ALL_LABEL')}
              options={getDropDownOptions(options.selectOptions, DropDownList)}
              valueField="key"
              labelField="value"
              element={{ value: options.name }}
            />
        break
      case 'text':
        component = (
          <input
            className="input-item"
            type={options.type}
            tabIndex={options.tabIndexes[0]}
            maxLength={options.maxLength}
            data-testid={options.name}
            {...register(options.name)} />
        )
        break
    }
    return component
  }

  const renderInputGroup = options => {
    let onBlur = null
    if (options.type === 'date' || options.type === 'month') onBlur = onDateBlur(options.name)
    if (options.type === 'number') onBlur = onNumberBlur(options.name)

    return (
      <>
        <div className="label-text"><label>{i18n.t(options.label)}</label></div>
        <div>
          <div data-testid={`${options.name}-input-group`} className="input-group" onBlur={onBlur}>{renderInput(options)}</div>
          {renderErrorText(options.name)}
        </div>
      </>
    )
  }

  return (
    <FilterTabWrapper>
      <form className="form-container" onSubmit={handleSubmit(onSubmit)} noValidate>
        <div className="filter-container">
          <div className="input-container">
            {renderInputGroup(fieldNames.code)}
            {renderInputGroup(fieldNames.rearLightingManufacturer)}
            {renderInputGroup(fieldNames.importantNotes)}
          </div>
          <div className="input-container">
            {renderInputGroup(fieldNames.dashcamManufacturer)}
            {renderInputGroup(fieldNames.sensorsManufacturer)}
          </div>
          <div className="input-container">
            {renderInputGroup(fieldNames.horizontalLaserManufacturer)}
            {renderInputGroup(fieldNames.attachment)}
          </div>
        </div>
        <div className="submit-container">
          <SearchButton data-testid="submit-button" tabIndex={34} type="submit" {...errorFields.length > 0 && { disabled: true }} />
        </div>
      </form>
    </FilterTabWrapper>
  )
}

DetailVehicleTab.propTypes = {
  onSearchSubmit: PropTypes.func,
  defaultValue: PropTypes.object
}
